import { addDays, addMonths, differenceInDays, differenceInMonths  } from 'date-fns';

import { PERIOD } from '@/Helpers/PeriodEnumType'

const isValidJSON = obj => {
    try {
      JSON.parse(obj);
      return true;
    } catch (e) {
      return false;
    }
};


const getDatesBetweenTwoDates = (startDate, endDate) => {
  const dates = []
  let currentDate = startDate
  const addDays = function (days) {
    const date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)
    return date
  }
  while (currentDate <= endDate) {
    dates.push(currentDate)
    currentDate = addDays.call(currentDate, 1)
  }
  return dates
}


// Returns an array of dates between the two dates
const getDatesBetweenTwoDatesWithTimes = (startDate, endDate) => {
  const dates = [];

  // Strip hours minutes seconds etc.
  let currentDate = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
  );

  while (currentDate <= endDate) {
      dates.push(currentDate);

      currentDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() + 1, 
          /* Will increase month if over range*/
      );
  }

  return dates;
};



const dateRangeBetweenTwoDates = (startDate, endDate, interval) => {
  if (interval === PERIOD.DAY) {
    const days = differenceInDays(endDate, startDate);

    return [...Array(days+1).keys()].map((i) => addDays(startDate, i));
  }

  if (interval === PERIOD.MONTH) {
    const months = differenceInMonths(endDate, startDate);

    return [...Array(months+1).keys()].map((i) => addMonths(startDate, i));
  }
}

function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
       const key = keyGetter(item);
       const collection = map.get(key);
       if (!collection) {
           map.set(key, [item]);
       } else {
           collection.push(item);
       }
  });
  return map;
}

export { isValidJSON, getDatesBetweenTwoDates, getDatesBetweenTwoDatesWithTimes, dateRangeBetweenTwoDates, groupBy }